import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-body-full',
  templateUrl: './body-full.component.html',
  styleUrls: ['./body-full.component.scss']
})
export class BodyFullComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
